import i18n from 'i18n';
import React from 'react';
import { ListAllLogs } from 'containers/Logs';
import { useParams } from 'react-router';

const AuditEnvironments = () => {
  const { id } = useParams<{ id: string }>();
  return (
    <ListAllLogs
      title={i18n.t('LOGS_PAGE.LIST_LOGS_KEY')}
      subtitle={i18n.t('LOGS_PAGE.LIST_LOGS_ENVIRONMENT_KEY')}
      context={'environment'}
      contextId={id}
      isContextPage
    />
  );
};

export default AuditEnvironments;
